import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PermissionsService } from '../services/permissions.service';

export function licenseInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const permissionsService = inject(PermissionsService);

  for (const excludeUrl of environment.excludeUrls) {
    if (req.url.includes(excludeUrl)) {
      return next(req);
    }
  }

  const license = permissionsService.activeLicense();

  if (!license) {
    return next(req);
  }

  const requestWithLicense = req.clone({
    headers: req.headers.set('license', license),
  });

  return next(requestWithLicense);
}
